const EXIF_START: number = 0xFFE1;
const EXIF_ORIENTATION_TAG: number = 0x0112;

const enum ExifOrientation {
    Landscape = 1,
    LandscapeFlipped = 3,
    Portrait = 6,
    PortraitFlipped = 8
}

export class MediaOrientationUtil {

    public static rotateImageFile(file: File): Promise<File> {
        return new Promise<File>(resolve => {
            const fileUrl = URL.createObjectURL(file);
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            if (context) {
                this.createImageElement(fileUrl).then(image => {

                    this.readFileIntoFileStream(file)
                        .then(this.determineIfImageMustBeRotated)
                        .then((exifOrientation: ExifOrientation) => {

                            canvas.width = exifOrientation === ExifOrientation.LandscapeFlipped ? image.width : image.height;
                            canvas.height = exifOrientation === ExifOrientation.LandscapeFlipped ? image.height : image.width;

                            // Landscape flipped
                            if (exifOrientation === ExifOrientation.LandscapeFlipped) {
                                context.transform(-1, 0, 0, -1, image.width, image.height);
                                context.drawImage(image, 0, 0, image.width, image.height);
                            }
                            // Portrait Button onder
                            else if (exifOrientation === ExifOrientation.Portrait) {
                                context.rotate(Math.PI / 2);
                                const xCorrection = image.height / 3;
                                context.drawImage(image, 0, -image.width + xCorrection, image.width, image.height);
                            }
                            // Portrait Button boven
                            else if (exifOrientation === ExifOrientation.PortraitFlipped) {
                                context.rotate(-(Math.PI / 2));
                                const yCorrection = image.height / 3;
                                context.drawImage(image, -image.height - yCorrection, 0, image.width, image.height);
                            }

                            canvas.toBlob((blob) => {
                                const blobFile: any = blob;
                                blobFile.lastModified = new Date();
                                blobFile.name = "Mooi_plaatje";

                                resolve(blobFile as File);
                            });
                        })
                        .catch(() => {
                            resolve(file);
                        });
                });
            }
            else {
                resolve(file);
            }
        });
    }

    private static readFileIntoFileStream(file: Blob): Promise<ArrayBuffer> {
        return new Promise<ArrayBuffer>(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as ArrayBuffer);
            reader.readAsArrayBuffer(file);
        });
    }

    private static createImageElement(fileData: string) {
        return new Promise<HTMLImageElement>(resolve => {
            const img = document.createElement("img");
            img.onload = () => resolve(img);
            img.src = fileData;
        });
    }

    private static determineIfImageMustBeRotated(buffer: ArrayBuffer): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            const scanner = new DataView(buffer);
            let idx = 0;
            let maxBytes = scanner.byteLength;
            let exifOrientation = 0;

            // Determine if buffer refers to an JPEG file.
            if (scanner.getUint16(idx) === 0xFFD8) {
                idx += 2;

                while (idx < maxBytes - 2) {
                    const uint16 = scanner.getUint16(idx);
                    idx += 2;
                    switch (uint16) {
                        case EXIF_START:
                            const exifLength = scanner.getUint16(idx);
                            maxBytes = exifLength - idx;
                            idx += 2;
                            break;

                        case EXIF_ORIENTATION_TAG:
                            // Read the value, its 6 bytes further out
                            // See page 102 at the following URL
                            // http://www.kodak.com/global/plugins/acrobat/en/service/digCam/exifStandard2.pdf
                            exifOrientation = scanner.getUint16(idx + 6, false);
                            maxBytes = 0; // Stop scanning                    
                            break;
                    }
                }
            }

            if (exifOrientation === ExifOrientation.LandscapeFlipped
                || exifOrientation === ExifOrientation.Portrait
                || exifOrientation === ExifOrientation.PortraitFlipped) {
                resolve(exifOrientation);
            }

            reject();
        });
    }
}


// WEBPACK FOOTER //
// ./src/Utils/MediaOrientationUtil.ts